import React from "react";
import Layout from "../components/layout";
import Card from "../components/card";

const Contact = () => {
  let members = [
    {
      name: "Nhan Pham",
      role: "Software Engineer",
      experience: "C#, Asp.net, Nodejs, React, Javascript, Html, Css, Java",
      more:
        "I enjoy playing volleyball and go on hikes on my free time. I enjoy reading while hanging on my hammock.",
      image_path: require("../assets/images/sf_louis.jpg"),
    },
    {
      name: "Kevin Pacheco",
      role: "Lead Software Engineer",
      experience: ".NET, Xamarin, Unity3D, Android, iOS",
      more:
        "I enjoy teaching. I love comedy movies and standup specials. I relax by playing guitar",
      image_path: require("../assets/images/kevin.jpg"),
    },
    {
      name: "Quilan Padgham",
      role: "Software Engineer",
      experience: "Java, Python, C++",
      more: "Big eSports fan",
      image_path: require("../assets/images/QuinPicture.jpg"),
    },
    {
      name: "Victoria Margaryan",
      role: "UI/UX, Software Engineer",
      experience: "Java, C#, JavaScript",
      more:
        "When not learning more about comp science, I love reading and drawing.",
      image_path: require("../assets/images/vic.jpg"),
    },
    {
      name: "Dat Hua",
      role: "UI/UX",
      experience: "Java, Selenium WebDriver, Android",
      more: "I doodle to stay focus and listen to audiobooks to fall asleep.",
      image_path: require("../assets/images/dat.jpg"),
    },
    {
      name: "Jason Wong",
      role: "Software Engineer",
      experience: "Java, C, Lua, Python",
      more:
        "I like to discover new features of technology. I was also a League of Legends cosplayer.",
      image_path: require("../assets/images/jason.jpg"),
    },
  ];
  return (
    <div>
      <Layout>
        <div className="my-8">
          <h1 className="text-2xl font-bold text-center py-2 text-gray-800 uppercase">
            Visio Novus
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:grid-cols-3 lg:gap-0 xl:mx-32">
            {members.map((member) => (
              <Card
                role={member.role}
                name={member.name}
                experience={member.experience}
                image_path={member.image_path}
                more={member.more}
                key={member.name}
              />
            ))}
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default Contact;
